import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 60px 20px 20px 20px;
  overflow-y: scroll;
  z-index: 100;
  display: none;
  @media (min-width: 1199px) {
    padding: 0;
    display: inline-block;
    position: absolute;
    right: 100px;
    top: 0;
    left: auto;
    bottom: auto;
    overflow: visible;
  }
  &.HeaderMenu-active {
    display: block;
    background:${colors.color1};
    @media (min-width: 1199px) {
      background:transparent;
    }
  }
  .HeaderMenu_menuClose {
    display: block;
    position: absolute;
    right: 18px;
    top: 20px;
    width: 20px;
    height: 20px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close-white.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 20px 20px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    @media (min-width: 1199px) {
      display: none;
    }
  }
  .HeaderMenu_menu {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    padding:0;
    @media (min-width: 1199px) {
      display: inline-block;
    }
  }
  .HeaderMenu_menuItem {
    list-style: none;
    border-bottom: 1px solid rgba(255,255,255,.1);
    @media (min-width: 1199px) {
      display: inline-block;
      margin: 0;
      vertical-align: top;
      border: 0;
      position: relative;
    }
  }
  .HeaderMenu_menuHeading {
    font-size: 16px;
    font-weight: 800;
    padding: 15px 0;
    background-image: url('/images/icon-triangle-white.svg');
    background-position: calc(100% - 16px) center;
    background-repeat: no-repeat;
    background-size: 8px 6px;
    cursor: pointer;
    display: block;
    color:white;
    outline:none;
    @media (min-width: 1199px) {
      font-weight: 700;
      cursor: default;
      position: relative;
      padding: 0 30px 0 15px;
      line-height: 100px;
      height: 100px;
      cursor: pointer;
      color:${colors.color5};
      background-image: url('/images/icon-triangle-blue.svg');
    }
  }
  a.HeaderMenu_menuHeading {
    background-image: none;
    padding: 15px 0;
    outline:none;
    @media (min-width: 1199px) {
      padding: 0 15px;
    }
  }

  a.HeaderMenu_menuHeading-phone {
    background-image: none;
    padding: 15px 0;
    outline:none;
    color:${colors.color1};
    font-weight: 700;
    font-size:18px;
    color:white;
    @media (min-width: 1199px) {
      padding: 0 15px;
      color:${colors.color1};
    }
  }
  .HeaderMenu_subMenu {
    display: none;
    list-style: none;
    margin: 0;
    position: relative;
    padding:0;
    @media (min-width: 1199px) {
      position: absolute;
      top: 100px;
      left: 0;
      width:auto;
      min-width: 240px;
      background-color: white;
    }
  }
  .HeaderMenu_subMenu-active {
    display: block;
  }
  .HeaderMenu_subMenuItem a {
    font-weight: 400;
    font-size: 16px;
    padding: 20px;
    display: block;
    transition: all .3s ease;
    border-bottom:rgba(255,255,255,.2);
    color:#ffffff;
    &:hover {

    }
    @media (min-width: 1199px) {
      font-weight: 700;
      color:${colors.color1};
      &:hover {
        background-color: ${colors.color3};
      }
    }
  }
`;

function HeaderMenu({ isActive, toggleMenu, isActiveMenu, activateMenu, builder }) {
  return (
    <div className={`${styles} ${isActive ? 'HeaderMenu-active' : ''}`} >
      <button className="HeaderMenu_menuClose" onClick={toggleMenu} />
      <ul className="HeaderMenu_menu">
        <li className="HeaderMenu_menuItem">
          <span tabIndex={0} role="button" className="HeaderMenu_menuHeading" onClick={activateMenu('find')}>Homebuilding Made Simple</span>
          <ul className={`${isActiveMenu('find') ? 'HeaderMenu_subMenu-active' : ''} HeaderMenu_subMenu`}>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="plans">Floor Plans</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="homebuilding-process">Homebuilding Process</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="design-center">Design Center</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="energy-efficiency">Energy Efficiency</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="financing-info">Financing Info</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="about-us">About Us</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="testimonials">Testimonials</Link></li>
          </ul>
        </li>
        <li className="HeaderMenu_menuItem">
          <span tabIndex={0} role="button" className="HeaderMenu_menuHeading" onClick={activateMenu('remodeling')}>Remodeling</span>
          <ul className={`${isActiveMenu('remodeling') ? 'HeaderMenu_subMenu-active' : ''} HeaderMenu_subMenu`}>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="kitchen-remodels">Kitchen Remodels</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="bathroom-remodels">Bathroom Remodels</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="basement-finishing">Basement Finishing</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="additions">Additions</Link></li>
          </ul>
        </li>
        <li className="HeaderMenu_menuItem">
          <span tabIndex={0} role="button" className="HeaderMenu_menuHeading" onClick={activateMenu('galleries')}>Galleries</span>
          <ul className={`${isActiveMenu('galleries') ? 'HeaderMenu_subMenu-active' : ''} HeaderMenu_subMenu`}>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="photo-gallery">Photo Gallery</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="video-gallery">Video Gallery</Link></li>
          </ul>
        </li>
        <li className="HeaderMenu_menuItem">
          <span tabIndex={0} role="button" className="HeaderMenu_menuHeading" onClick={activateMenu('contact')}>Contact Us</span>
          <ul className={`${isActiveMenu('contact') ? 'HeaderMenu_subMenu-active' : ''} HeaderMenu_subMenu`}>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="contact-us">Contact Us</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="refer-a-friend">Refer A Friend</Link></li>
            <li className="HeaderMenu_subMenuItem"><Link onClick={toggleMenu} name="warranty-request">Warranty Request</Link></li>
          </ul>
        </li>
        <li className="HeaderMenu_menuItem">
          <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="HeaderMenu_menuHeading HeaderMenu_menuHeading-phone">{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
        </li>
      </ul>
    </div>
  );
}

HeaderMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
  builder: PropTypes.object.isRequired,
};

export default menuToggler(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js